import { call, all, put, takeLatest } from "redux-saga/effects";

import {
  getTask,
  getTaskById,
  setTask,
  setTaskById,
  setTaskLoading,
  taskTypes as types,
} from "../actions";
import { AxiosResponse } from "axios";
import { EntityIdPayload } from "../../../utils";
import showNotification from "../../../services/notificationService";
import {
  addTaskService,
  getTaskService,
  getTaskByIdService,
  deleteTaskByIdService,
  editTaskService,
  learnerSubmitTaskService,
  approveSubmitTaskService,
} from "../../../services/educator/task";

export default function* educatorTaskSagas() {
  yield all([
    takeLatest(types.CREATE_TASK, handleCreateTask),
    takeLatest(types.GET_TASK, handleGetTask),
    takeLatest(types.GET_TASK_BY_ID, handleGetTaskById),
    takeLatest(types.DELETE_TASK, handleDeleteTask),
    takeLatest(types.EDIT_TASK, handleEditTask),
    takeLatest(types.LEARNER_SUBMIT_TASK, handleLearnerSubmitTask),
    takeLatest(types.APPROVE_TASK_SUBMIT, handleApproveTaskSubmit),
  ]);
}

function* handleCreateTask(action: any) {
  yield put(setTaskLoading(true));
  const { data }: AxiosResponse = yield call(
    addTaskService,
    action.payload.task
  );

  yield put(setTaskLoading(false));
  if (data) {
    yield put(getTask());
    showNotification("success", "Task created successfully!");
    action.payload.navigate(`/educator/task`);
  }
}

function* handleGetTask(action: any) {
  const { data }: AxiosResponse = yield call(
    getTaskService,
    action?.payload?.query
  );

  if (data) {
    yield put(setTask({ tasks: data }));
  }
}

function* handleDeleteTask(action: any) {
  const { data }: AxiosResponse = yield call(
    deleteTaskByIdService,
    action.payload.id
  );

  if (data) {
    showNotification("success", "Task deleted successfully");
    yield put({ type: types.GET_TASK });
  }
}

function* handleGetTaskById(action: EntityIdPayload) {
  const { data }: AxiosResponse = yield call(
    getTaskByIdService,
    action.payload.id
  );

  if (data) {
    yield put(setTaskById({ task: data }));
  }
}

function* handleEditTask(action: any) {
  yield put(setTaskLoading(true));
  const { data }: AxiosResponse = yield call(
    editTaskService,
    action.payload.id,
    action.payload.task
  );
  yield put(setTaskLoading(false));

  if (data) {
    showNotification("success", "Task edited successfully!");
    yield put(getTaskById({ id: action.payload.id }));
  }
}

function* handleLearnerSubmitTask(action: any) {
  yield put(setTaskLoading(true));
  const { data }: AxiosResponse = yield call(
    learnerSubmitTaskService,
    action.payload.id
  );

  yield put(setTaskLoading(false));
  if (data) {
    yield put(getTask());
    showNotification("success", "Task submitted successfully!");
    action.payload.navigate(`/user/task`);
  }
}

function* handleApproveTaskSubmit(action: any) {
  yield put(setTaskLoading(true));
  const { data }: AxiosResponse = yield call(
    approveSubmitTaskService,
    action.payload.submissionId,
    action.payload.isApproved
  );

  yield put(setTaskLoading(false));
  if (data) {
    yield put(getTaskById({ id: action.payload.taskId }));
    showNotification(
      "success",
      `Submission ${
        action.payload.isApproved ? "approved" : "disapproved"
      } successfully!`
    );
  }
}
